module.exports = __webpack_public_path__ + "assets/img/block-left-3b04e4ec.png";